import { currentEnv } from './env';

export const auth0Config = currentEnv.auth;
